import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import localstorage from 'src/helper/localstorageGame'

export default class {
  @observable data = { 
    uid:0,
    canSet:true,
    login:true,
    notGame:false,
    notNetwork:false,
    tokenErr:false,
    gameCoinList:[],
    gold:0,
    gameCoinSelect:0,
    rankList:{
      wealth:[],
      score:[]
    }
  }

  @action async setUid(uid) {
    this.data.uid = uid || 0
  }

  @action async setNotGame() {
    this.data.notGame = true
  }

  @action async setCoin(i) {
    this.data.gameCoinSelect = i
  }

  @action async setGameData(gameId,d) {  
    this.data.notNetwork = false  
    this.data.tokenErr = false
    if (this.data.canSet == true && d.indexOf('code:')==-1 && d.indexOf('res:')==-1 && d.indexOf('msg:')==-1) {
      this.data.canSet = false
      let r = await http.post('/web/game/set/data', {gameId: gameId, save: d })
      this.data.canSet = true
      if (r && r.res) {
        return true
      }else{
        if (r.code && r.code==11) {
          //在其他地方登录
          this.data.tokenErr = true
        }else{
          //设置失败，可能没有连上网络，要求用户不要退出当前游戏，否则可能没法保存游戏进度
          //todo
          this.data.notNetwork = true
        }
        return false
      }
    }
  }

  @action async getGameData(game, storeKey) {   
    let d = await http.post('/web/game/get', {gameId: game })
    if (d && d.res && d.code == 0 ) {
      if (d.res.save!='' && d.res.save!='{}'  && d.res.save!=undefined) {
        //获得线上存档
        console.log("设置游戏本地存档", d.res.save)
        localstorage.set(storeKey, d.res.save)
      }else{
        //网络通的情况下，又没有数据，则清空本地存档
        localstorage.remove(storeKey)
      }
      return true //可以继续游戏
    }
    this.data.login=false
    return false
  }

  @action async getGameCoins(game) {   
    let d = await http.post('/web/GameCoinList', {gameId: game })
    if (d && d.res && d.code == 0 ) {
      this.data.gameCoinList=d.res
    }
  }

  @action async GetUserInfoWeb() {
    if (this.data.uid>0) {
      let d = await http.post('/web/MyAccountInfo', {uid:this.data.uid})
      if (d && d.code == 0 && d.res) {
        this.data.gold = d.res.gold || 0
      }
    }
  }

  @action async Exchange() {
    if (this.data.gameCoinList[this.data.gameCoinSelect].coins>this.data.gold ||this.data.gameCoinList.length==0 || (this.data.gameCoinList.length-1)<this.data.gameCoinSelect) {
      //金币不足
      return
    }
    let d = await http.post('/web/game/exchange', {id:this.data.gameCoinList[this.data.gameCoinSelect].id})
    if (d && d.code==0) {
      return true
    }
    return false
  }

  @action async Rank(game) {
    let ts = Date.parse(new Date())
    // if (ts<1661979600) {//9月之前按月统计排名
    //   let d = await http.post('/web/game/month/rank', {gameId:game})
    //   console.log(d)
    //   this.data.rankList=d.res
    // }else{//9月之后按周计算排名
    //   let d = await http.post('/web/game/rank', {gameId:game})
    //   console.log(d)
    //   this.data.rankList=d.res
    // }
    let d = await http.post('/web/game/rank', {gameId:game})
    console.log(d)
    this.data.rankList=d.res
  }
}



// WEBPACK FOOTER //
// src/store/app/games.js